module.exports = __webpack_public_path__ + "static/6-person-arrow-hands-9a535841eb597dcc1e4f4efb6953842a.png";